// React imports
import React from 'react';

// UI – style imports
import { WithStyles, withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';

// local imports
import { styles } from './Identity.style';
import ID from 'components/ID';

function Identity(props: WithStyles<typeof styles>) {
    const { classes } = props;

    return (
        <Box className={classes.root}>
            <Box className={classes.textContainer}>
                <Box id="titleContainer">
                    <p className="title">ES</p>
                    <p className="title" id="bot">
                        PARA
                    </p>
                    <p className="title" id="bot">
                        TODOS,
                    </p>
                    <p id="sub">abre tu cuenta</p>
                </Box>

                <p id="explanation">
                    Obtener una cuenta en Cuenca es muy sencillo: descarga la aplicación, regístrate y comienza a vivir
                    en la era digital.
                    <br />
                    <br />
                    Para abrir tu cuenta necesitas contar con tu identificación oficial vigente. El registro es rápido y
                    podrás empezar a usar tu cuenta en minutos.
                    <br />
                    <br />
                    En Cuenca contamos con tres niveles de cuenta, diseñados para adaptarse a tus necesidades. Para
                    acceder al Nivel 3, es necesario proporcionar documentación adicional y completar el proceso de
                    verificación correspondiente.
                </p>
            </Box>

            <Box id="idContainer">
                <Box className="smallMarginRight">
                    <ID type="ine" orientation="right" />
                </Box>
                <Box className="bigMarginRight">
                    <ID type="pasaporte" orientation="left" />
                </Box>
                <Box className="smallMarginRight">
                    <ID type="residencia" orientation="right" />
                </Box>
            </Box>
        </Box>
    );
}

export default withStyles(styles)(Identity);
